// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-left {
  font: 10px Arial, sans-serif;
  text-align: center;
}

a {
  font-size: 14px;
  font-weight: normal;
}

.secure-logo {
  border: 0;
  width: 100px;
  height: 50px;
}

.secure-link {
  width: 115px;
}`, "",{"version":3,"sources":["webpack://./src/app/U2011_login/U2011_verifyidentity/U2011_verifyidentity.component.scss"],"names":[],"mappings":"AAIA;EAEI,4BAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,eAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,SAAA;EACA,YAAA;EACA,YAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ","sourcesContent":["\n@import \"../../U2000_style/U2000_style-mixins\";\n@import \"../../U2000_style/U2000_style-variables\";\n\n.media-left {\n    //min-width: 140px;\n    font: 10px Arial, sans-serif;\n    text-align: center;\n}\n\na {\n    font-size: 14px;\n    font-weight: normal;\n}\n\n.secure-logo {\n    border: 0;\n    width: 100px;\n    height: 50px;\n}\n\n.secure-link {\n    width: 115px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
